import React from "react";
import { connect } from "react-redux";
import { Button, Input, Row } from "antd";
import { startVerifyChannel } from "../actions/auth";
import VerifyImg from "../assets/images/smsVerify.svg";
import * as R from "ramda";
import "../styles/components/verify-popup.scss";

const defaultState = {
  0: undefined,
  1: undefined,
  2: undefined,
  3: undefined,
  4: undefined,
  5: undefined,
};
class VerifyPopUp extends React.Component {
  constructor(props) {
    super(props);

    this.state = defaultState;

    this.inputs = [];
  }

  onChange = (e) => {
    const val = e.target.value;
    const name = e.target.name;
    const numberOfInputs = R.keys(this.state).length;
    if (val === "") {
      if (name !== "0") {
        this._changeFocus((parseInt(name, 10) - 1) % numberOfInputs);
        this.setState((prevState) => ({ [(parseInt(name, 10) - 1) % numberOfInputs]: undefined }));
      }
    } else {
      this.setState((prevState) => ({ [name]: val }));
      if (val) this._changeFocus((parseInt(name, 10) + 1) % numberOfInputs);
    }
  };

  onSubmit = async () => {
    const values = R.values(this.state);
    const code = values.join("");
    const res = await this.props.startVerifyChannel(
      this.props.channel_type,
      this.props.value,
      code
    );
    if (res) {
      this.props.closePopUp();
    } else {
      this.setState(() => defaultState);
    }
  };

  _addInput = (index) => {
    return (input) => {
      this.inputs[index] = input;
    };
  };

  _changeFocus = (index) => {
    this.inputs[index].focus();
  };

  render() {
    return (
      <div className="verify-popup">
        <img src={VerifyImg} alt="verify sms" />
        <h3>Verification Code</h3>
        <p>We have sent a verification code to {this.props.value}</p>
        <Row className="inputs">
          <Input
            name="0"
            autoFocus
            value={this.state["0"]}
            onKeyUp={this.onChange}
            maxLength={1}
            ref={this._addInput(0)}
          />
          <Input
            name="1"
            value={this.state["1"]}
            onKeyUp={this.onChange}
            maxLength={1}
            ref={this._addInput(1)}
          />
          <Input
            name="2"
            value={this.state["2"]}
            onKeyUp={this.onChange}
            maxLength={1}
            ref={this._addInput(2)}
          />
          <Input
            name="3"
            value={this.state["3"]}
            onKeyUp={this.onChange}
            maxLength={1}
            ref={this._addInput(3)}
          />
          <Input
            name="4"
            value={this.state["4"]}
            onKeyUp={this.onChange}
            maxLength={1}
            ref={this._addInput(4)}
          />
          <Input
            name="5"
            value={this.state["5"]}
            onKeyUp={this.onChange}
            maxLength={1}
            ref={this._addInput(5)}
          />
        </Row>

        <Button
          type="primary"
          size="large"
          shape="round"
          className="verify-btn"
          onClick={this.onSubmit}
        >
          Verify
        </Button>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  startVerifyChannel: (channel_type, value, token) =>
    dispatch(startVerifyChannel(channel_type, value, token)),
});

export default connect(undefined, mapDispatchToProps)(VerifyPopUp);
